import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AggregationService } from '../_services/aggregation.service';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { LocalStorageService } from '../_services/local-storage.service';
import { PersonSearchService } from '../_services/person-search.service';
import * as _ from 'underscore';


@Component({
  selector: 'app-person-search-ai',
  templateUrl: './person-search-ai.component.html',
  styleUrls: ['./person-search-ai.component.scss']
})
export class PersonSearchAiComponent implements OnInit {

  companyname: any;
  @Input() requestaidata;
  @Input() insightstabname;
  statsdata: any;
  @Input() totalcount;
  aidata: any = ''
  filterdata: any;
  locationsfilterdata: any = [];
  skillsfilterdata: any = [];
  functionsfilterdata: any = [];
  aifilter: any
  showshimmerloader: boolean = false;
  quicksearchdata: any;
  @Input() keyword;
  @Input() insightsaidata;
  @Input() events: Observable<void>;
  totalTenureMedian: any;
  changedJobs: any;
  insightsdata: any = '';
  aisubscription: Subscription;
  constructor(private router: Router, private personsearchservice: PersonSearchService, private localstorageservice: LocalStorageService,
    private aggregationservice: AggregationService, private filterDataHandlerService: FilterDataHandlerService, private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.events.subscribe((event: any) => {
      this.insightsdata = event;
      if (event) {
        const locations = event.topLocations.map(elm => ({ Location: elm.key, 'Talent Count': elm.doc_count }));
        const companies = event.dataSourceCurrentCompany && event.dataSourceCurrentCompany.data.map(elm => ({ Company: elm.label, 'Talent Count': elm.value }));
        const industries = event.currentIndustry && event.currentIndustry.map(elm => ({ Industry: elm.key, 'Talent Count': elm.doc_count }));
        const schools = event.school && event.school.map(elm => ({ Schools: elm.key, 'Talent Count': elm.doc_count }));
        const fieldofstudies = event.fieldOfStudy && event.fieldOfStudy.map(elm => ({ 'Field of Study': elm.key, 'Talent Count': elm.doc_count }));
        const skills = event.skills && event.skills.map(elm => ({ 'Skills': elm.key, 'Talent Count': elm.doc_count }));
        const jobtitles = event.titles && event.titles.map(elm => ({ 'Job Title': elm.key, 'Talent Count': elm.doc_count }));
        const totaltenure = event.dataSourceCurrentExperience && event.dataSourceCurrentExperience.data && event.dataSourceCurrentExperience.data.map(elm => ({ 'Total Tenure': elm.label, 'Talent Count': elm.value }))
        const currenttenure = event.dataSourceExpInCurrentRole && event.dataSourceExpInCurrentRole.data && event.dataSourceExpInCurrentRole.data.map(elm => ({ 'Tenure in current company': elm.label, 'Talent Count': elm.value }))
        const seniority = event.dataSourceSeniority && event.dataSourceSeniority.data && event.dataSourceSeniority.data.map(elm => ({ 'Seniority': elm.label, 'Talent Count': elm.value }))


        this.quicksearchdata = {
          locations: locations,
          companies: companies,
          industries: industries,
          schools: schools,
          fieldofstudies: fieldofstudies,
          skills: skills,
          jobtitles: jobtitles,
          totaltenures: totaltenure,
          currenttenures: currenttenure,
          seniority: seniority

        }
      }
    })
    this.aggregationservice.getStatsAggs();
    this.aggregationservice.statsUpdateEvent.subscribe(res => this.getcountdata(res));
    this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.getfilterdata());
    this.keyword = this.route.snapshot.queryParams.keyword;
  }

  generateai() {
    this.showshimmerloader = true;
    this.keyword = this.route.snapshot.queryParams.keyword;
    this.aidata = '';
    const payload = {
      data: this.quicksearchdata,
      filters: this.aifilter,
      totaltenuremedian: this.totalTenureMedian,
      talentcount: this.totalcount,
      changedjobscount: this.changedJobs,
      changedjobsdurationinmonths: 12,
      booleanquery: this.keyword ? this.keyword: '*'

    }
    this.aisubscription = this.personsearchservice.getquicksearchsummary(payload).subscribe((res: any) => {
      this.aidata = res.data;
      this.showshimmerloader = false
      this.aidata = this.aidata.replace(/(?:\r\n|\r|\n)/g, '<br>')
    })
  }

  getfilterdata() {

    this.filterdata = this.filterDataHandlerService.fetchFilterData;
    this.aifilter = {
      locations: this.filterdata && this.filterdata.locationSelectedList.length ? this.filterdata.locationSelectedList.filter(l => l.isExcluded == false).map(l => l.key) : [],
      functions: this.filterdata && this.filterdata.functionSelectedList ? this.filterdata.functionSelectedList.map(l => l.key) : [],
      preferredskills: this.filterdata && this.filterdata.skillsSelectedList.length ? this.filterdata.skillsSelectedList.filter(s => s.isMandatory == false).map(s => s.key) : [],
      jobtitles: this.filterdata && this.filterdata.jobTitleSelectedList.length ? _.uniq(this.filterdata.jobTitleSelectedList.filter(jobTitle => jobTitle.isExcluded == false).map(j => j.key)) : [],
      companies: this.filterdata && this.filterdata.companySelectedList.length ? this.filterdata.companySelectedList.filter(company => company.isExcluded == false).map(j => j.key) : [],
      companysizes: this.filterdata.companysize ? [this.filterdata.companysize] : [],
      industries: this.filterdata && this.filterdata.industrySelectedList.length ? this.filterdata.industrySelectedList.map(industry => industry.key) : [],
      seniorities: this.filterdata.seniority.length ? _.flatten(this.filterdata.seniority) : [],
      genders: this.filterdata.gender ? [this.filterdata.gender] : [],
      educationaldegrees: this.filterdata.educationSelectedList.length ? this.filterdata.educationSelectedList.map(e => e.key) : [],
      schools: this.filterdata.schoolSelectedList.length ? this.filterdata.schoolSelectedList.map(s => s.key) : [],
      fieldofstudies: this.filterdata.fieldOfStudySelectedList.length ? this.filterdata.fieldOfStudySelectedList.map(fs => fs.key) : [],
      likelytomovetypes: this.filterdata.candidateslikelytomove ? [this.filterdata.candidateslikelytomove] : [],
      fromyearsofexperiences: this.filterdata && this.filterdata.yearsofexperienceFrom ? [this.filterdata.yearsofexperienceFrom] : [],
      toyearsofexperiences: this.filterdata && this.filterdata.yearsofexperienceTo ? [this.filterdata.yearsofexperienceTo] : [],
      currentfromyearsofexperiences: this.filterdata && this.filterdata.currentfromyearsofexperience ? [this.filterdata.currentfromyearsofexperience] : [],
      currenttoyearsofexperiences: this.filterdata && this.filterdata.currenttoyearsofexperience ? [this.filterdata.currenttoyearsofexperience] : [],
      mandatoryskills: this.filterdata.skillsSelectedList.length ? this.filterdata.skillsSelectedList.filter(s => s.isMandatory == true).map(s => s.key) : []
    }
    this.aidata = '';
    this.showshimmerloader = false;
    if(this.aisubscription)
      this.aisubscription.unsubscribe();
  }

  getcountdata(res) {
    const response = res.find(el => !!el.data.aggregations.total_tenure_median);
    this.totalTenureMedian = response.data && response.data.aggregations && response.data.aggregations.total_tenure_median && response.data.aggregations.total_tenure_median.value || 0;

    const changeddata = res.find(el => !!el.data.aggregations.changedjobs);
    this.changedJobs = changeddata.data && changeddata.data.aggregations && changeddata.data.aggregations.changedjobs && changeddata.data.aggregations.changedjobs.doc_count;

  }


}
